<div
  *ngIf="amusementText() as text"
  class="text"
  [ngClass]="{ 'in-category': inCategory }"
>
  {{ text }}
</div>
